export default __webpack_public_path__ + "static/media/pin_other.8054774f.png";